<template>
  <div v-if="!mount"></div>
  <Start
    :title="title"
    @home="home"
    @start="$store.commit('changeQuestion', 0)"
    v-else-if="now === -1"
  >
  </Start>

  <QuestionPage v-else @home="home" @goIndex="goIndex" @end="end" />
</template>

<script>
/* eslint-disable no-console */

import Start from "@/components/questionPages/Start/Index.vue";
import QuestionPage from "@/components/questionPages/Question/Index.vue";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

export default {
  name: "Question",
  components: {
    Start,
    QuestionPage
  },
  props: {
    modal: Boolean,
    history: Object,

    qidx: Number,
    orderList: Array,
    answered: Array,
    gap: Number,
    wrap: Number
  },
  created() {
    // this.loadConfig();
  },
  data() {
    return {
      selected: null,
      self: null,

      config: {
        limitTime: null,
        limit: false,
        continue: true,
        random: false,
        audio: false,
        expectLastCorrect: false
      },

      loaded: false,

      public: process.env.BASE_URL,
      circleNum: [
        "①",
        "②",
        "③",
        "④",
        "⑤",
        "⑥",
        "⑦",
        "⑧",
        "⑨",
        "⑩",
        "⑪",
        "⑫",
        "⑬",
        "⑭",
        "⑮",
        "⑯",
        "⑰",
        "⑱",
        "⑲",
        "⑳"
      ],
      sentList: [],
      backShow: true,

      limitTime: null,
      limit: false,
      timer: {},
      timerStopper: false,
      timerNext: {},

      optionOrderList: [],
      allSelectedList: [],

      openTop: false,
      openCheck: false,

      openAudio: false,
      openVideo: false,

      mount: false,

      transitionName: "prev",
      transition: false,
      input: [],

      dragging: false,
      initPosition: { x: 0, y: 0 },
      position: 0,
      blockHeight: 0,
      textBlockHeight: "auto",

      limitTimer: {},

      comment: false,
      pause: false
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.mount = true;
    });
    /*
    this.timerStart();
    window.addEventListener("focus", this.restartTimer);
    window.addEventListener("blur", this.stopTimer);
    */
  },
  beforeDestroy() {
    /*
    window.removeEventListener("focus", this.restartTimer);
    window.removeEventListener("blur", this.stopTimer);
    */
  },
  computed: {
    drill() {
      return this.$store.getters.drill;
    },
    now() {
      return this.$store.state.questionId;
    },
    sent() {
      if (this.modal) {
        return true;
      } else {
        return this.sentList[this.now];
      }
    },
    qComment() {
      return this.nowQuestion.comment;
    },
    list() {
      return this.$store.getters.list;
    },
    title() {
      if (this.setting) {
        return this.setting.title.split("\n").join("<br>");
      }
      return null;
    },
    nowQuestion() {
      return this.$store.getters.drill1;
    },

    optionsOrder() {
      return this.optionOrderList[this.now];
    },
    options() {
      if (this.nowQuestion.question.random) {
        return this.optionsOrder.map(e => {
          return this.nowQuestion.question.option[e];
        });
      }
      return this.nowQuestion.question.option;
    },
    answer() {
      let optionsOrder;
      if (
        this.nowQuestion.question.type === "order" ||
        this.nowQuestion.question.type === "multiple"
      ) {
        const answers = this.nowQuestion.question.answer.map(e => e - 1);
        if (!this.optionsOrder) {
          optionsOrder = this.makeOptions();
        } else {
          optionsOrder = this.optionsOrder;
        }
        if (optionsOrder) {
          return optionsOrder.map(e => answers.indexOf(e));
        }
        return [-1];
      } else if (this.nowQuestion.question.type === "input") {
        return this.nowQuestion.question.answer;
      }
      const answer = this.nowQuestion.question.answer - 1;
      if (!this.optionsOrder) {
        optionsOrder = this.makeOptions();
      } else {
        optionsOrder = this.optionsOrder;
      }
      return optionsOrder.findIndex(e => e === answer);
    },

    selectedList() {
      if (
        this.nowQuestion.question.type === "order" ||
        this.nowQuestion.question.type === "multiple"
      ) {
        return this.options.map((e, idx) => {
          if (Array.isArray(this.selected)) {
            return this.selected.indexOf(idx);
          }
          return -1;
        });
      }
      return [];
    },

    selectedOrder() {
      const p = [];
      this.selected.forEach((e, idx) => {
        p[e] = idx;
      });

      return p;
    },

    multipleAnswer() {
      return this.answer.map(e => {
        return e !== -1;
      });
    },
    multipleSelected() {
      return this.answer.map((e, idx) => {
        return this.selected.indexOf(idx) !== -1;
      });
    },

    inputAnswer() {
      return this.nowQuestion.question.answer.map((e, idx) => {
        if (this.res) {
          if (this.res[idx]) {
            if (Array.isArray(e)) {
              return (
                e.map(a => String(a)).indexOf(String(this.res[idx])) !== -1
              );
            }
            return String(e) === String(this.res[idx]);
          }
          return null;
        } else {
          return null;
        }
      });
    },
    inputResponse() {
      return this.nowQuestion.question.answer.map((e, idx) => {
        if (this.res) {
          if (this.res[idx]) {
            return String(this.res[idx]);
          }
          return null;
        } else {
          return null;
        }
      });
    },
    inputPlaceHolder() {
      return this.nowQuestion.question.answer.map((e, idx) => {
        if (Array.isArray(this.options)) {
          return this.options[idx] || `解答欄${idx + 1}`;
        }
        return `解答欄${idx + 1}`;
      });
    },

    tof() {
      if (
        this.nowQuestion.question.type === "select" ||
        this.nowQuestion.question.type === "dropdown"
      ) {
        return this.answer === this.selected;
      } else if (this.nowQuestion.question.type === "order") {
        return this.answer.every((e, idx) => e === this.selectedList[idx]);
      } else if (this.nowQuestion.question.type === "input") {
        console.log("input");
        return this.inputAnswer.filter(e => {
          return e === true;
        }).length >= this.nowQuestion.question.answer.length
          ? true
          : false;
      } else if (this.nowQuestion.question.type === "multiple") {
        return this.answer.every((e, idx) => {
          if (e === -1) {
            return this.selectedList[idx] === -1;
          } else {
            return this.selectedList[idx] !== -1;
          }
        });
      }
      return this.self;
    },
    res() {
      if (
        this.nowQuestion.question.type === "select" ||
        this.nowQuestion.question.type === "order" ||
        this.nowQuestion.question.type === "multiple" ||
        this.nowQuestion.question.type === "dropdown"
      ) {
        return this.selected;
      } else if (this.nowQuestion.question.type === "input") {
        return this.input;
      } else if (this.nowQuestion.question.type === "self") {
        return this.selected;
      }
      return this.selected;
    },

    nextDisabled() {
      return this.modal || this.list.length - 1 <= this.now;
    },
    prevDisabled() {
      return this.modal || 0 === this.now;
    }
  },
  methods: {
    openModalSound() {
      this.stopTimer();
      this.openAudio = true;
    },

    closeModalSound() {
      this.restartTimer();
      console.log("close sound");
      this.openAudio = false;
    },
    openModalMovie() {
      this.stopTimer();
      this.openVideo = true;
    },
    closeModalMovie() {
      this.restartTimer();
      console.log("close");
      this.openVideo = false;
    },

    goIndex() {
      this.$store.commit("startQuestion", this.$store.state.drillId);
    },

    home() {
      this.$store.commit("home");
    },
    /*
    correct() {
      this.self = true;
      this.selected = true;
      this.send();
    },
    fault() {
      this.self = false;
      this.selected = false;
      this.send();
    },

    send(end) {
      console.log("send" + this.now);
      console.log(this.res);
      if (Array.isArray(this.nowQuestion.question.answer)) {
        this.nowQuestion.question.answer.forEach((e, idx) => {
          if (this.$refs[`input${idx}`]) {
            if (this.$refs[`input${idx}`][0]) {
              this.$refs[`input${idx}`][0].blur();
            }
          }
        });
      }

      if (!this.sentList[this.now]) {
        let res = this.res;
        let tof = this.tof;
        if (end === true) {
          res = null;
          tof = false;
        }
        const senddata = {
          listNo: this.now,
          id: this.list[this.now],
          res: res,
          tof: tof
        };
        this.$set(this.sentList, this.now, true);
        this.$emit("set", senddata);
      }

      if (end !== true) {
        if (this.config.audio) {
          if (this.tof) {
            this.$refs.goodmp3.play();
          } else {
            this.$refs.badmp3.play();
          }
        }
        if (this.config.continue && !this.timerStopper) {
          this.timerNext = setTimeout(() => {
            if (!this.timerStopper) {
              this.next(true);
            }
          }, 3000);
        }
      }
    },
    */
    end() {
      this.$store.commit("end");
    },

    makeOptions() {
      if (!this.optionOrderList[this.now] && this.nowQuestion.question.option) {
        const order = [];
        this.nowQuestion.question.option.forEach((e, idx) => {
          order.push(idx);
        });
        if (this.nowQuestion.question.random) {
          this.$set(this.optionOrderList, this.now, this.randomizer(order));
        }
        this.optionOrderList[this.now] = order;
        return order;
      }
    }
  },
  watch: {
    now() {
      /*
      console.log("now changed:" + nv);
      this.loaded = false;

      this.openVideo = false;
      this.openAudio = false;

      this.comment = false;
      clearTimeout(this.timerNext);
      if (!this.modal && nv >= 0) {
        console.log("init");
        clearTimeout(this.timer);
        if (
          !this.sent &&
          !this.allSelectedList[nv] &&
          this.allSelectedList[nv] !== 0
        ) {
          if (
            this.nowQuestion.question.type === "order" ||
            this.nowQuestion.question.type === "multiple"
          ) {
            console.log("selected set cleared array");
            this.selected = [];
          } else if (this.nowQuestion.question.type === "input") {
            this.input = [];
          } else {
            console.log("selected set null");
            this.selected = null;
            this.self = null;
          }
        } else {
          this.selected = this.allSelectedList[this.now];
          this.input = this.allSelectedList[this.now];
        }

        if (!this.sentList[nv]) {
          this.$set(this.sentList, nv, false);
        }
        window.scrollTo(0, 0);
        this.limit = this.config.limit;
        this.limitTime = this.config.limitTime;
        this.restartTimer();
        this.timerStart();

        this.makeOptions();
      }
      this.$nextTick(() => {
        if (!this.modal) {
          window.scrollTo(0, 0);
        }
        this.loaded = true;
        this.blockHeight = "auto";

        this.$nextTick(() => {
          // this.blockInit();
        });
      });
      */
    },
    optionOrderList(nv) {
      console.log("changed optionsOrderList: " + nv);
      if (!this.modal) {
        this.$emit("optionsOrderList", nv);
      }
    },
    selected(nv) {
      this.$set(this.allSelectedList, this.now, nv);
    },
    input(nv) {
      this.$set(this.allSelectedList, this.now, nv);
    },
    allSelectedList(nv) {
      this.$emit("allSelectedList", nv);
    } /*
    expectLastCorrect(nv) {

      console.log("expect");
      console.log(nv);
      this.$emit("setConfig", { key: "expectLastCorrect", value: nv });
    }*/
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media screen and (orientation: landscape) {
  .page {
    display: flex;
    flex-direction: column;
  }

  .page-wrap {
    height: 100%;
  }

  #question {
    display: flex;
    width: 100%;
    height: calc(100% - 140px);

    max-width: 90%;
  }

  .input-container {
    display: flex;

    flex-direction: column;
    justify-content: center;

    flex: 0 0 40%;
    padding-left: 2.5%;
  }
}

.mo-win .page-wrap {
  height: calc(100% - 2.5rem);
}

.mo-win .page {
  height: 100%;
  overflow: auto;
}

video {
  width: 100%;
}

.presentation-block {
  width: 100%;
  display: flex;
  justify-items: center;
  align-items: center;
}

.swiper-button-prev,
.swiper-button-next {
  flex: 0 0 44px;
  cursor: pointer;
}

.contents-wrap {
  width: 100%;
  height: 100%;
}

.presentation.hasOption.img {
  height: calc(100% - 58px);
  max-height: calc(100% - 58px);
}

.presentation img {
  width: 100%;
}

.disabled .setting-configs {
  opacity: 0.3;
}

.answer {
  color: #d22;
  font-size: 80%;
}

.num-box {
  display: inline-block;
  margin: 2px 0;
  width: 2em;
  background-color: #fff;
  border-radius: 10px;

  border: solid 3px #c4c4c4;
  color: #444;

  text-align: center;
}

.num-box.answer {
  font-size: 20px;
  border: solid 3px #ff4444;
  margin-right: 5px;
}

.answer-list.center li {
  text-align: center;
}

.list-btn {
  display: inline-block;
  width: calc(100% - 3em);
}

.item,
.answer-list li {
  display: flex;
}

.item div.boxes,
.answer-list li div.boxes {
  flex: 0 0 4em;
  text-align: right;
}

.order-list li div.boxes,
.multi-list li div.boxes {
  flex: 0 0 6em;
}

.item div.options,
.answer-list li div.options {
  flex: 1 0 auto;
  padding-left: 0.5em;
}

.btn-fusen {
  display: block;
  margin: 2rem auto;
  width: 9em;
  font-size: 1.5rem;
  line-height: 2.5rem;
  border-radius: 4rem;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  -webkit-box-shadow: 3px 3px 15px 3px rgba(0, 0, 0, 0.1);
  box-shadow: 3px 3px 15px 3px rgba(0, 0, 0, 0.1);
  letter-spacing: 0.2em;
  border: none;
}

.reset {
  display: block;
  margin: 1rem 0 0 auto;
  width: 9em;
  font-size: 1.5rem;
  line-height: 2.5rem;
  background: #3553a7;
  border-radius: 4rem;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  -webkit-box-shadow: 3px 3px 15px 3px rgba(0, 0, 0, 0.1);
  box-shadow: 3px 3px 15px 3px rgba(0, 0, 0, 0.1);
  color: #fff;
  letter-spacing: 0.2em;

  border: none;
}

.reset:disabled {
  opacity: 0.5;
}

.option {
  cursor: pointer;
}

.q-option {
  cursor: pointer;
}

.btn-answer {
  cursor: pointer;
}

.q-option-container {
  text-align: right;
}

.tag.has-option .presentation {
  height: calc(100% - 72px);
}
</style>
